module.exports = __webpack_public_path__ + "static/media/location_on.d0eddea3.svg";